/* eslint-disable react/no-unescaped-entities */
import {useState} from "react";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";
import {main_menu} from "../../data/main_menu";

function Icon({id, open}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7"/>
    </svg>
  );
}

const FaqAccordion = ({faq_data}) => {
  const [open, setOpen] = useState(0);

  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);
  };

  return (
    <div className="mb-14">
      {faq_data.map((item) => (
        <Accordion
          className="mb-5 overflow-hidden rounded-lg border border-jacarta-50 dark:border-jacarta-600"
          open={open === item.id}
          icon={<Icon id={item.id} open={open}/>}
        >
          <AccordionHeader
            className="accordion-button relative flex w-full items-center justify-between bg-white px-4 py-3 text-left font-display text-jacarta-700 dark:bg-jacarta-700 dark:text-white text-md"
            onClick={() => handleOpen(item.id)}
          >
            {item.question}
          </AccordionHeader>
          <AccordionBody className="accordion-body border-t border-jacarta-50 bg-white p-4 dark:border-jacarta-600 dark:bg-jacarta-700 text-base h-full">
            {item.answer}
          </AccordionBody>
        </Accordion>
      ))}
    </div>
  );
};

export default FaqAccordion;
